import ReactDOM from 'react-dom';

// React 19 removed ReactDOM.findDOMNode, but semantic-ui-react (Ref/Portal/
// Popup/Modal/Dropdown and similar older libraries) still call it to locate
// the host DOM node of a trigger/child. Provide a minimal replacement that
// walks the React fiber to return the underlying DOM element.
if (!ReactDOM.findDOMNode) {
  const getFiber = (instance) => {
    if (instance._reactInternals) return instance._reactInternals;
    if (instance._reactInternalFiber) return instance._reactInternalFiber;
    // React 19 exposes the fiber under a hashed key like `__reactFiber$...`.
    const key = Object.getOwnPropertyNames(instance).find((k) =>
      k.startsWith('__reactFiber$'),
    );
    return key ? instance[key] : null;
  };

  ReactDOM.findDOMNode = function findDOMNode(componentOrElement) {
    if (componentOrElement == null) return null;
    if (componentOrElement.nodeType === 1) return componentOrElement;

    const fiber = getFiber(componentOrElement);
    if (!fiber) return null;

    let current = fiber;
    while (current) {
      const node = current.stateNode;
      if (node && node.nodeType === 1) return node;
      current = current.child;
    }
    return null;
  };
}
